import { Injectable } from '@angular/core';
import { TherapyprogressDataService } from './therapyprogress-data.service';

declare var Chart;
declare var ChartDataLabels;

type DataPoint = number | null;
export interface WoundChartData {
  labels: string[];
  lengthData: DataPoint[];
  widthData: DataPoint[];
  depthData: DataPoint[];
}

@Injectable({
  providedIn: 'root',
})
export class WoundhistoryChartService {
  constructor(readonly therapyprogressDataService: TherapyprogressDataService) {}

  public async getWoundChartBase64(
    woundChartData: WoundChartData,
    height = 600,
    width = 800
  ): Promise<string /* base64 */> {
    return this.renderToBase64(height, width, woundChartData);
  }

  private createLinearGradient(context: CanvasRenderingContext2D, from: string, to: string) {
    const gradient = context.createLinearGradient(0, 0, 0, 300);
    gradient.addColorStop(0, from);
    gradient.addColorStop(1, to);
    return gradient;
  }

  private async renderToBase64(height: number, width: number, rawWoundChartData: WoundChartData): Promise<string> {

    // wound height / length / area is saved in mm in database. 
    // standardized display is cm, therefore we convert it to cm

    rawWoundChartData.widthData = rawWoundChartData.widthData.map((value) => {
      const convertedValue = value / 10;
      return  Math.round(convertedValue * 10) / 10;
    })
    rawWoundChartData.lengthData = rawWoundChartData.lengthData.map((value) => {
      const convertedValue = value / 10;
      return  Math.round(convertedValue * 10) / 10;
    })
    rawWoundChartData.depthData = rawWoundChartData.depthData.map((value) => {
      const convertedValue = value / 10;
      return  Math.round(convertedValue * 10) / 10;
    })

    const container = document.createElement('div');
    let canvas = document.createElement('canvas');
    container.setAttribute(
      'style',
      `position: absolute; left: -10000px; top: -10000px; width: ${width}px !important; height: ${height}px !important`
    );
    container.append(canvas);
    document.body.appendChild(container);
    canvas.setAttribute('style', `display: none`);
    const context = canvas.getContext('2d');
    if (!context) {
      throw new Error('canvas context not available');
    }
    const lengthFillGradient = this.createLinearGradient(context, 'rgb(46, 91, 255,0.2)', 'rgba(46, 91, 255, 0)');
    const heightFillGradient = this.createLinearGradient(context, 'rgb(0, 179, 162, 0.2)', 'rgba(0, 179, 162, 0)');
    const depthFillGradient = this.createLinearGradient(context, 'rgb(255, 179, 0,0.2)', 'rgba(255, 179, 0, 0)');

    return new Promise<string>((resolve, reject) => {
      const datasets = [
        {
          label: 'Tiefe',
          data: rawWoundChartData.depthData,
          backgroundColor: depthFillGradient,
          borderColor: 'rgb(255, 179, 0)',
          borderWidth: 2,
          fill: 'origin',
          datalabels: {
            color: 'rgb(255, 179, 0)',
          },
        },
        {
          label: 'Breite',
          data: rawWoundChartData.widthData,
          backgroundColor: heightFillGradient,
          borderColor: 'rgb(0, 179, 162)',
          borderWidth: 2,
          fill: 'origin',
          datalabels: {
            color: 'rgb(0, 179, 162)',
          },
        },
        {
          label: 'Länge',
          data: rawWoundChartData.lengthData,
          backgroundColor: lengthFillGradient,
          borderColor: 'rgb(46, 91, 255)',
          borderWidth: 2,
          fill: 'origin',
          datalabels: {
            color: 'rgb(46, 91, 255)',
          },
        },
      ];

      function exportBase64Image(this: any) {
        try {
          resolve(this.toBase64Image());
        } catch (e) {
          reject(e);
        } finally {
          canvas = null as any;
        }
      }

      const chart = new Chart(canvas, {
        type: 'line',
        data: {
          labels: rawWoundChartData.labels,
          datasets,
        },
        plugins: [Chart.Filler, ChartDataLabels],
        options: {
          animation: {
            onComplete: exportBase64Image,
          },
          spanGaps: true,
          responsive: true,
          plugins: {
            datalabels: {
              align: 'top',
              clamp: true,
              'padding.bottom': 30,
            },
          },
          scales: {
            x: {
              display: true,
              title: {
                display: true,
              },
            },
            y: {
              display: true,
              title: {
                display: true,
                text: 'cm',
              },
            },
          },
        },
      } as any);
    });
  }
}
